import React from "react";
import { Form } from "antd";

import { EInputType, TransactionDetail } from "Modules/TransactionDetail";

import { IExpenseTrxnsDetails } from "Views/Transaction/@types";
import { includesReversalTrxns } from "Views/Transaction/Helper";
import { useExpenseForm } from "Views/Transaction/Details/useExpenseForm";
import { EXPENSE_INPUT_DETAILS_OPTIONS, MULTIPLE_CR_DETAILS_OPTIONS } from "Views/Transaction/Constants";
import { useRemoveSubscriptionModal } from "Views/Transaction/Modal/Subscriptions";

export const Details = ({
  taxId,
  notes,
  details,
  receipts,
  trxnType,
  trxnNumber,
  categoryId,
  categoryName,
  closeDetails,
  handleSaveRef,
  tags,
  expenseReceipts,
  taxName,
  subscriptionId,
  lineItems,
  disableEditing = false,
  isMultipleCR = false,
  subscriptionInitialProps,
}: IExpenseTrxnsDetails) => {
  const { form, buttonAction, defaultValue, setFormValue, onDeleteFile } = useExpenseForm(
    trxnNumber,
    closeDetails,
    receipts,
    notes,
    taxId,
    categoryId,
    null,
    tags,
    expenseReceipts,
    subscriptionId
  );

  const { openModal } = useRemoveSubscriptionModal(subscriptionId, trxnNumber, () => {
    form.setFieldsValue({
      [EInputType.SUBSCRIPTION]: null,
    });
  });

  handleSaveRef.current = buttonAction;

  return (
    <Form form={form}>
      <TransactionDetail
        form={form}
        details={details}
        defaultValue={defaultValue}
        setFormValue={setFormValue}
        missingFields={defaultValue}
        visibleInput={isMultipleCR ? MULTIPLE_CR_DETAILS_OPTIONS : EXPENSE_INPUT_DETAILS_OPTIONS}
        disabled={disableEditing || includesReversalTrxns(trxnType)}
        onDeleteFile={onDeleteFile}
        categoryFallback={categoryName}
        taxFallback={taxName}
        ignoreRequiredCheck
        onRemoveSubscription={openModal}
        showDSBanner={isMultipleCR}
        bannerProps={
          isMultipleCR && {
            variant: "neutral",
            title: "This transaction contains multiple expenses",
            // TODO add once reimbursement deeplink is working
            // description:
            //   "You can view and edit category, tags, attachments or notes for each individual item in this transaction",
          }
        }
        showLineItems={isMultipleCR}
        lineItems={lineItems}
        subscriptionInitialProps={!isMultipleCR && subscriptionInitialProps}
      />
    </Form>
  );
};
